module.exports = __webpack_public_path__ + "static/media/Wa.1a44a3fc.svg";